var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-methods"},_vm._l((_vm.paymentMethods),function(method){return _c('PaymentMethod',{key:method.id,attrs:{"paymentMethod":method,"defaultMethod":_vm.isDefault(method)},on:{"selected":_vm.onSelected}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }